import { useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import { getAvailableBoxSizes } from 'actions/basket'
import userActions from 'actions/user'
import { getIsAuthenticated } from 'selectors/auth'
import { getAvailableNumPortions } from 'selectors/basket'
import { getUserId } from 'selectors/user'

export const useGlobalBootstrap = () => {
  const dispatch = useDispatch()
  const availableBoxSize = useSelector(getAvailableNumPortions)?.length ?? 0
  const isAuthenticated = useSelector(getIsAuthenticated)
  const userId = useSelector(getUserId)

  useEffect(() => {
    if (availableBoxSize === 0) {
      dispatch(getAvailableBoxSizes())
    }

    if (isAuthenticated && !userId) {
      dispatch(userActions.userLoadData())
    }
  }, [availableBoxSize, isAuthenticated, userId, dispatch])
}
